module.exports = __webpack_public_path__ + "static/super-admin-user-list-bf093a325c587e750df3faf7d06b2c4b.png";